import { useState } from "react";

const RECENT_OFFICES_KEY = "recent-offices";
const MAX_RECENT = 3;

const getStoredRecentOffices = () => {
  try {
    const stored = localStorage.getItem(RECENT_OFFICES_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

const useRecentOffices = () => {
  const [recentOffices, setRecentOffices] = useState(getStoredRecentOffices);

  const addRecentOffice = (office) => {
    if (!office?.id || !office?.name) return;
    // Write to localStorage synchronously BEFORE updating React state,
    // because a page reload may fire immediately after this call.
    const current = getStoredRecentOffices();
    const filtered = current.filter((o) => String(o.id) !== String(office.id));
    const updated = [{ id: office.id, name: office.name }, ...filtered].slice(
      0,
      MAX_RECENT
    );
    localStorage.setItem(RECENT_OFFICES_KEY, JSON.stringify(updated));
    setRecentOffices(updated);
  };

  return [recentOffices, addRecentOffice];
};

export default useRecentOffices;
